import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useFooter } from '../../hooks/useFooter'
import FooterService from '../user/common/services/FooterService';
// import playStore from './../../assets/images/play-store.png';
// import appStore from './../../assets/images/app-store.png';
import bitcoin from './../../assets/images/bitcoin.svg';
import litecoin from './../../assets/images/litecoin.svg';
import monerocoin from './../../assets/images/monero.svg';
import americanExpress from './../../assets/images/american-express.svg';
import paypal from './../../assets/images/paypal.svg';
import citi from './../../assets/images/citi.svg';
import bitcoinCard from './../../assets/images/bitcoin-card.svg';
import envelopeIcon from './../../assets/icons/envelope-icon.svg';
import linkedinIcon from './../../assets/icons/linkedin.svg';
import twitterIcon from './../../assets/icons/twitter.svg';
import facebook from './../../assets/icons/facebook.svg';
import instagram from './../../assets/icons/instagram.svg';
import whatsapp from './../../assets/icons/whatsapp.svg';
import github from './../../assets/icons/github.png';
import pinterest from './../../assets/icons/pinterest-icon.svg';
import reddit from './../../assets/icons/reddit-tile.svg';
import snapchat from './../../assets/icons/snapchat-tile.svg';
import telegram from './../../assets/icons/telegram-icon.svg';
import tiktok from './../../assets/icons/tiktok-icon.svg';
import youtube from './../../assets/icons/youtube-icon.svg';

const Footer = ({ page = 'all' }) => {
    const { footerSections, loading, error } = useFooter(page);
    const [newsletterEmail, setNewsletterEmail] = useState('');
    const [isSubscribing, setIsSubscribing] = useState(false);

    const handleNewsletterSubmit = async (event) => {
        event.preventDefault();

        const email = newsletterEmail.trim();
        if (!email) {
            toast.error('Please enter your email address.');
            return;
        }

        setIsSubscribing(true);
        try {
            const response = await FooterService.subscribeNewsletter(email);
            if (response.status) {
                toast.success(response.message);
                setNewsletterEmail('');
            } else {
                toast.error(response.message || 'Unable to subscribe. Please try again.');
            }
        } catch (error) {
            const message = error.response?.data?.message || 'Unable to subscribe. Please try again.';
            toast.error(message);
        } finally {
            setIsSubscribing(false);
        }
    };

    // Helper function to determine if a URL is external
    const isExternalLink = (url) => {
        return url.startsWith('http://') ||
               url.startsWith('https://') ||
               url.startsWith('mailto:') ||
               url.startsWith('tel:') ||
               url.startsWith('ftp://');
    };

    const getSocialIcon = (iconName) => {
        const iconMap = {
            'linkedin': linkedinIcon,
            'twitter': twitterIcon,
            'facebook': facebook,
            'instagram': instagram,
            'whatsapp': whatsapp,
            'github': github,
            'pinterest': pinterest,
            'reddit': reddit,
            'snapchat': snapchat,
            'telegram': telegram,
            'tiktok': tiktok,
            'youtube': youtube
        };
        return iconMap[iconName?.toLowerCase()] || null;
    };

    return (
        <footer className="footer">
            <div className="container">
           
                <div className="row">
                    <div className="col-sm-12">
                        <div className="top">
                            <p className="mb-0">I want to get daily deals & offers in my email</p>
                            <form className="d-flex" onSubmit={handleNewsletterSubmit}>
                                <div>
                                    <img src={envelopeIcon} alt="envelope-icon" loading="lazy" decoding="async" />
                                    <input
                                        className="form-control rounded-0 border-0"
                                        type="email"
                                        placeholder="Email address"
                                        aria-label="Email address"
                                        value={newsletterEmail}
                                        onChange={(event) => setNewsletterEmail(event.target.value)}
                                        disabled={isSubscribing}
                                        required
                                    />
                                </div>
                                <button className="btn btn_dark" type="submit" disabled={isSubscribing}>
                                    {isSubscribing ? 'Subscribing...' : 'Subscribe'}
                                </button>
                            </form>
                            <div className="play_store_box">
                                {/* <Link to="#"><img src={playStore} alt="play-store" loading="lazy" decoding="async" /></Link> */}
                            </div>
                            <div className="app_store_box">
                                {/* <Link to="#"><img src={appStore} alt="app-store" loading="lazy" decoding="async" /></Link> */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row gy-3 gy-5 gy-sm-3 py-5 body">

                    {!loading && !error && footerSections.map((section, index) => (
                        <div key={section._id} className="col-xs-12 col-md-4 col-lg-3">
                            <h6 className={`title ${section.isSocialMedia ? 'mt-5' : ''}`}>{section.name}</h6>

                            {section.isSocialMedia ? (
                                <div className="social_links">
                                    {section.links.map((link) => {
                                        const iconImage = getSocialIcon(link.icon);
                                        return isExternalLink(link.url) ? (
                                            <a
                                                key={link._id}
                                                href={link.url}
                                                target={link.target}
                                                rel={link.target === '_blank' ? 'noopener noreferrer' : undefined}
                                                className="d-inline-block me-2"
                                            >
                                                {iconImage ? (
                                                    <img src={iconImage} alt={link.text} loading="lazy" decoding="async" />
                                                ) : (
                                                    <i className={`fab fa-${link.icon}`} style={{ fontSize: '32px' }}></i>
                                                )}
                                            </a>
                                        ) : (
                                            <Link
                                                key={link._id}
                                                to={link.url}
                                                target={link.target}
                                                rel={link.target === '_blank' ? 'noopener noreferrer' : undefined}
                                                className="d-inline-block me-2"
                                            >
                                                {iconImage ? (
                                                    <img src={iconImage} alt={link.text} loading="lazy" decoding="async" />
                                                ) : (
                                                    <i className={`fab fa-${link.icon}`} style={{ fontSize: '32px' }}></i>
                                                )}
                                            </Link>
                                        );
                                    })}
                                </div>
                            ) : (
                                <ul className="links-list">
                                    {section.links.map((link) => (
                                        <li key={link._id}>
                                            {isExternalLink(link.url) ? (
                                                <a
                                                    href={link.url}
                                                    target={link.target}
                                                    rel={link.target === '_blank' ? 'noopener noreferrer' : undefined}
                                                >
                                                    {link.icon && <i className={`${link.icon} me-2`}></i>}
                                                    {link.text}
                                                </a>
                                            ) : (
                                                <Link
                                                    to={link.url}
                                                    target={link.target}
                                                    rel={link.target === '_blank' ? 'noopener noreferrer' : undefined}
                                                >
                                                    {link.icon && <i className={`${link.icon} me-2`}></i>}
                                                    {link.text}
                                                </Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>
                
                <div className="row">
                    <div className="col-sm-12">
                        <div className="bottom">
                            <p className="mb-0">pay.earth {new Date().getFullYear()}. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;